import type {
  ProductTag,
  CreateProductTagDto,
  UpdateProductTagDto,
  GetAllProductTagsResponse,
  DeleteProductTagResponse,
} from '../model/types'
import { useApi } from '@shared/api'

/**
 * Публичный API тегов продуктов.
 * Базовый URL: /api/v2/product-tags
 */
class APIProductTags {
  /**
   * Получить активные теги заведения.
   * GET /api/v2/product-tags/{institutionId}
   */
  async getActiveTagsByInstitution(institutionId: number): Promise<ProductTag[]> {
    const { data } = await useApi(true).get<GetAllProductTagsResponse>(`/product-tags/${institutionId}`)
    return data.tags
  }
}

/**
 * Административный API тегов продуктов.
 * Базовый URL: /api/v2/admin/product-tags
 */
class APIAdminProductTags {
  async getAll(includeInactive = false): Promise<ProductTag[]> {
    const { data } = await useApi(true, true).get<GetAllProductTagsResponse>(
      `/admin/product-tags?include_inactive=${includeInactive}`,
    )
    return data.tags
  }

  async getById(id: number): Promise<ProductTag> {
    const { data } = await useApi(true, true).get<ProductTag>(`/admin/product-tags/${id}`)
    return data
  }

  async create(payload: CreateProductTagDto): Promise<ProductTag> {
    const { data } = await useApi(true, true).post<ProductTag>('/admin/product-tags', { body: payload })
    return data
  }

  async update(id: number, payload: UpdateProductTagDto): Promise<ProductTag> {
    const { data } = await useApi(true, true).patch<ProductTag>(`/admin/product-tags/${id}`, { body: payload })
    return data
  }

  async delete(id: number): Promise<DeleteProductTagResponse> {
    const { data } = await useApi(true, true).delete<DeleteProductTagResponse>(`/admin/product-tags/${id}`)
    return data
  }
}

export const apiProductTags = new APIProductTags()
export const apiAdminProductTags = new APIAdminProductTags()
